export default (url) => {
  return url.substring(url.lastIndexOf(".", url.lastIndexOf(".") - 1) + 1);
}